// Mirrors the API's [Email] attribute (EmailValidation package, allowTopLevelDomains: false,
// allowInternational: true) so users get a friendly error here instead of a failed save.
// Non-ASCII characters are allowed anywhere a letter is, to match allowInternational.
const atom = "[A-Za-z0-9!#$%&'*+/=?^_`{|}~\\u0080-\\uFFFF-]+";
const localPart = `${atom}(?:\\.${atom})*`;
const label =
  '[A-Za-z0-9\\u0080-\\uFFFF](?:[A-Za-z0-9\\u0080-\\uFFFF-]{0,61}[A-Za-z0-9\\u0080-\\uFFFF])?';
const topLevelDomain = '(?:[A-Za-z\\u0080-\\uFFFF]{2,63}|xn--[A-Za-z0-9-]{1,59})';
const emailRegex = new RegExp(`^${localPart}@(?:${label}\\.)+${topLevelDomain}$`);

const MAX_LOCAL_PART_LENGTH = 64;
const MAX_EMAIL_LENGTH = 254;

export const isEmail = (email: string) => {
  // the API trims strings before validating, so surrounding whitespace is not an error
  const trimmed = email.trim();
  if (trimmed.length > MAX_EMAIL_LENGTH) return false;
  if (trimmed.indexOf('@') > MAX_LOCAL_PART_LENGTH) return false;

  return emailRegex.test(trimmed);
};
